import { combineReducers } from 'redux';

import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import profileReducer from '../features/profile/profileSlice';
// import statusReducer from '../containers/dashboard/statusSlice';
import apiLookupReducer from '../containers/api-lookup/apiLookupSlice';
import  usersSliceReducer from '../features/users/usersSlice'
import  awsSliceReducer from '../features/aws/awsSlice'

const allReducers = {
  auth: authReducer,
  profile: profileReducer,
  apiLookup: apiLookupReducer,
  users: usersSliceReducer,
  aws:awsSliceReducer
  // status: statusReducer,
};

const combinedReducer = combineReducers(allReducers);

const rootReducer = (state, action) => {
  if (action.type === 'reset') {
    return combinedReducer(undefined, action);
  }
  return combinedReducer(state, action);
};

export default configureStore({
  reducer: rootReducer,
});
